module.exports = __webpack_public_path__ + "static/img/weixin.3eb380d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin.jpg
// module id = /bMT
// module chunks = 1